/**
 * One source for how the signed-in person and the workspace are named in the
 * app frame (UX-208). The phone header, the desktop sidebar and the More sheet
 * all read these, so the phone can't show "[DEMO] Jordan Reese" while the
 * desktop shows "Jordan Reese".
 */

/** Seed/test accounts carry a "[DEMO] " / "[TEST] " prefix; show the real name. */
export function displayName(name: string | null | undefined, fallback = 'Account'): string {
  const clean = (name ?? '').replace(/^\s*\[(DEMO|TEST)\]\s*/i, '').trim()
  return clean || fallback
}

/**
 * Two-letter mark for the workspace tile ("CB Built Homes" → "CB"). Letters
 * only, so a "[DEMO] …" name or a leading digit never becomes the mark.
 */
export function workspaceMonogram(name: string | null | undefined): string {
  const words = (name ?? '')
    .replace(/^\s*\[(DEMO|TEST)\]\s*/i, '')
    .split(/\s+/)
    .map((w) => w.replace(/[^\p{L}]/gu, ''))
    .filter(Boolean)
  if (words.length === 0) return ''
  const first = words[0]
  // "CB Built Homes": an all-caps first word is already the business's own
  // abbreviation — use it rather than "CB" + "B".
  if (first.length <= 3 && first === first.toUpperCase()) return first
  return (words[0][0] + (words[1]?.[0] ?? '')).toUpperCase()
}
